import { Typography } from '@mui/material';
import { CasBaseDialog, CasButton, CasStackRow } from 'src/compass/shared/components';
import HubspotLink from 'src/compass/application/entityMaintenance/HubspotLink';
import { ICustomerSearchItem } from './customerSearchItem';

interface IProps {
  item: ICustomerSearchItem;
  onClose: VoidFunction;
}

/*
  What the Customers page search box opens for a result with no customer behind it: an account
  no customer is assigned to, or a HubSpot company no customer is tied to. A company can still be
  opened in HubSpot from the icon in the title.
*/
export default function UnassignedResultDialog({ item, onClose }: IProps) {
  const name = item.accountShort ? `${item.name} (${item.accountShort})` : item.name;

  return (
    <CasBaseDialog
      open
      maxWidth="sm"
      onClose={onClose}
      showCloseIcon
      title={
        <CasStackRow alignItems="center">
          {item.itemType === 'Company' && <HubspotLink id={item.itemId} recordPath="record/0-2" />}
          <span>{`${item.typeLabel}: ${name}`}</span>
        </CasStackRow>
      }
      actions={
        <div style={{ textAlign: 'center', flexGrow: 1 }}>
          <CasButton onClick={onClose}>OK</CasButton>
        </div>
      }
    >
      <Typography>{`${name} isn't assigned to a customer.`}</Typography>
    </CasBaseDialog>
  );
}
